import React, { useEffect, useState } from 'react';
import FarmLevelReportTable from './ManageProjectsTable';
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  OverlayTrigger,
  Popover,
  Row,
  Tooltip
} from 'react-bootstrap';
import FalconCardHeader from 'components/common/FalconCardHeader';
import useApi from 'hooks/useApi';
import {
  getExportAllData,
  getFarmTableData
} from 'api/endpoints/TerrestrialServices';
import { get } from 'lodash';
import { jwtDecode } from 'jwt-decode';
import { isEmpty } from 'lodash';
import { faDownload, faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CustomSpinner from 'components/common/CustomSpinner';
import CardDropdown from 'components/common/CardDropdown';
import { getTenantFromToken } from 'utils/routeUtils';

function FarmLevelReport() {
  const tenant = getTenantFromToken();

  const getExportAllApi = useApi(getExportAllData);

  const getFarmTableDataAPI = useApi(getFarmTableData);
  const [showFilter, setShowFilter] = useState(false);
  const [exportdata, setExportData] = useState(null);
  const [exportKey, setExportKey] = useState(null);

  const [show, setShow] = useState(false);
  const [target, setTarget] = useState(null);

  const handleFilterToggle = () => {
    setShowFilter(!showFilter);
  };

  // Update block list when blocks API data changes
  useEffect(() => {
    const data = get(getExportAllApi, 'data.results', []);
    if (!isEmpty(data)) {
      const s3Link = data; // Assuming the S3 link is in the first block
      downloadFile(s3Link);
    }
  }, [getExportAllApi.data]);

  // Function to download the file from S3 link
  const downloadFile = url => {
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', '');
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };

  const handleDownload = () => {
    const csvData = convertToCSV(exportdata);
    const filename = `FarmlandReport.csv`;
    downloadCSV(csvData, filename);
  };

  const convertToCSV = data => {
    // Extract headers from the first farmland_report, excluding 'color' and 'farm_id'
    const headers = Object.keys(
      data[Object.keys(data)[0]].farmland_report
    ).filter(key => key !== 'color' && key !== 'farm_id');

    // Capitalize headers
    const capitalizedHeaders = headers.map(key =>
      key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase())
    );

    // Map data rows for each location, excluding 'color' fields
    const dataRows = Object.values(data).map(item => {
      return headers.map(header => {
        const value = item.farmland_report[header];
        return typeof value === 'object' && value !== null
          ? value.value
          : value;
      });
    });

    // Combine headers and data rows into CSV format
    const csvContent = [
      capitalizedHeaders.join(','), // Join headers with commas
      ...dataRows.map(row => row.join(',')) // Join each data row with commas
    ].join('\n'); // Join all rows with newlines

    return csvContent;
  };

  const downloadCSV = (csvData, filename) => {
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('hidden', '');
    a.setAttribute('href', url);
    a.setAttribute('download', filename);
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const handleExportClick = event => {
    setShow(!show);
    setTarget(event.target);
  };

  const handleDownloadAll = () => {
    // Your download all logic here
    let tenant_id = tenant;
    getExportAllApi.request(tenant_id);
  };

  return (
    <div>
      <Row>
        <Col>
          <Card>
            <FalconCardHeader
              title="Farm Monitoring Report"
              titleTag="h5"
              light={true}
              endEl={
                <div className="d-flex justify-content-end my-auto">
                  <div
                    className="px-2 my-auto theme-control-toggle"
                    onClick={handleFilterToggle}
                  >
                    <OverlayTrigger
                      key="filter"
                      placement={'bottom'}
                      overlay={<Tooltip id="FilterData">Filter</Tooltip>}
                    >
                      <div className="theme-control-toggle-label">
                        <FontAwesomeIcon icon={faFilter} className="fs-0" />
                      </div>
                    </OverlayTrigger>
                  </div>
                  <CardDropdown
                    onExport={handleDownload}
                    onExportAll={handleDownloadAll}
                    exportKey={exportKey}
                  />
                </div>
              }
            />
            <CardBody>
              {/* {getProjectListsAPI.loading ? (
                <CustomSpinner />
              ) : isEmpty(projectLists) ? (
                <p className="text-center">No Projects Found</p>
              ) : (
                <ManageProjectsTable
                  data={projectLists}
                  deletePorjectAPI={deletePorjectAPI}
                  startProcessingAPI={startProcessingAPI}
                />
              )} */}
              {getFarmTableDataAPI.loading ? (
                <CustomSpinner />
              ) : (
                <FarmLevelReportTable
                  // tableData={tableData.data}
                  key={'SOIL_WATER_RETENTION_CAPACITY'}
                  hyperlink={false}
                  showFilter={showFilter}
                  setExportData={setExportData}
                  setExportKey={setExportKey}
                />
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

export default FarmLevelReport;
